import axios from 'axios'

export default class BasePublicApiClient {
  constructor () {
    this.client = axios.create({
      baseURL: process.env.VUE_APP_PUBLIC_API_PROXY_DOMAIN
    })
  }

  async getPaginated (route, params = {}, options = {}, dataKey = 'data') {
    const { data: response } = await this.client.get(route, { params, ...options })
    if (!response.page || !response.page.next_page_key) {
      return response[dataKey]
    }
    const nextPageParams = {
      ...params,
      page_size: response.page.page_size,
      page_key: response.page.next_page_key
    }
    const nextPages = await this.getPaginated(route, nextPageParams, options, dataKey)
    return [...response[dataKey], ...nextPages]
  }
}
